import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import template from "templates/modules/overlays/saved_search_confirmation_prompt.jinja";
import Overlay from "web/script/utils/overlay";
import globalEvents from "web/script/utils/global-events";
import { gettext } from "web/script/modules/django-i18n";

import "web/script/components/saved-search-delete-confirmation";

let overlay;

export default baustein.register("saved-search-delete", {
    defaultOptions: {
        deleteSavedSearchId: null,
    },

    setupEvents(add) {
        add("click", this.onClick);
    },

    onClick() {
        analytics.event("click", "delete saved search");
        this.openOverlay();
    },

    openOverlay() {
        overlay = new Overlay({
            cssClasses: ["size-m", "white"],
            content: template({
                saved_search_id: this.options.deleteSavedSearchId,
                title: gettext("your_lysts.delete_lyst.title"),
                no: gettext("your_lysts.delete_lyst.cancel_btn_text"),
                yes: gettext("your_lysts.delete_lyst.confirm_btn_text"),
            }),
            onOverlayClose: () => {
                analytics.event("dismissed saved search unsubscribe prompt", "clicked");
            },
        });
        globalEvents.on("confirmation-prompt-closed", this.closeOverlay.bind(this));
    },

    closeOverlay() {
        overlay.close();
        globalEvents.off("confirmation-prompt-closed", this.closeOverlay);
    },
});
